var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8432 18.3114V13.6238C12.8432 13.4166 12.7609 13.2179 12.6144 13.0714C12.4678 12.9249 12.2691 12.8426 12.0619 12.8426H8.93693C8.72973 12.8426 8.53101 12.9249 8.3845 13.0714C8.23799 13.2179 8.15568 13.4166 8.15568 13.6238V18.3114C8.15568 18.5186 8.07338 18.7173 7.92689 18.8638C7.7804 19.0103 7.58171 19.0926 7.37453 19.0927L2.6876 19.0933C2.58499 19.0933 2.48339 19.0731 2.3886 19.0338C2.2938 18.9946 2.20766 18.937 2.13511 18.8645C2.06255 18.7919 2.005 18.7058 1.96573 18.611C1.92646 18.5162 1.90625 18.4146 1.90625 18.312V9.28269C1.90625 9.17385 1.92899 9.06621 1.97302 8.96667C2.01705 8.86713 2.08139 8.77788 2.16192 8.70466L9.97389 1.60165C10.1177 1.4709 10.3051 1.39844 10.4994 1.39844C10.6938 1.39843 10.8812 1.47087 11.025 1.60162L18.838 8.70466C18.9186 8.77788 18.9829 8.86713 19.027 8.96667C19.071 9.06622 19.0938 9.17387 19.0938 9.28272V18.312C19.0938 18.4146 19.0735 18.5162 19.0343 18.611C18.995 18.7058 18.9374 18.7919 18.8649 18.8645C18.7923 18.937 18.7062 18.9946 18.6114 19.0338C18.5166 19.0731 18.415 19.0933 18.3124 19.0933L13.6243 19.0927C13.4171 19.0926 13.2185 19.0103 13.072 18.8638C12.9255 18.7173 12.8432 18.5186 12.8432 18.3114V18.3114Z",
    stroke: "#4F7D9C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueHouse);
export default __webpack_public_path__ + "static/media/blueHouse.a7af87e82eb19e1b66c6046887a0bdef.svg";
export { ForwardRef as ReactComponent };